import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import ProductImageDecorated from '@sprinx/react-com/ProductImageDecorated';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import ChipColored from '@sprinx/react-mui-components/ChipColored';
import { CatalogueProduct } from '../../../api/products/catalogue';
import useProductAdornmentsMapper from '../../../api/products/useProductAdornmentsMapper';
import ProductDetailLink from '../../../components/ProductDetailLink';
import ProductDiscountPercentElement from '../../../components/ProductDiscountPercentElement';

export interface CataloguePageListContentItemCardImageProps
  extends StandardDivProps<CataloguePageListContentItemCardImageClassKey> {
  product: CatalogueProduct;
  to: string;
}

export type CataloguePageListContentItemCardImageClassKey = 'root' | 'image' | 'middle' | 'outletChipWrapper';

const themeSettings = { name: 'CataloguePageListContentItemCardImage' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardImageClassKey, {}>({
      root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      middle: {
        [theme.breakpoints.down('sm')]: {
          flexGrow: 0,
        },
      },
      outletChipWrapper: {
        '& .MuiChip-label': {
          color: `${theme.palette.common.white} !important`,
          fontWeight: 600,
        },
      },
      image: {
        width: '100%',
        maxWidth: '100%',
        '& > div': {
          width: '100%',
          height: 0,
          paddingBottom: '100%',
          position: 'relative',
          maxWidth: theme.spacing(26),
          margin: '0 auto',
          marginBottom: theme.spacing(1),
        },
        '& img': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        },
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardImage = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardImageProps
>(({ className, classes: pClasses, product, to, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const imageAdornments = useProductAdornmentsMapper('row', product.adornments, product);
  // const currency = useRecoilValue(currencyState);
  // const to = useProductUrl(product);

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <ProductDetailLink to={to}>
        {product.taxonomies?.includes('/catalogue/outlet') && (
          <span className={classes.outletChipWrapper}>
            <ChipColored label='OUTLET' color='#FFA800' size='small' />
          </span>
        )}
        <ProductImageDecorated
          {...imageAdornments}
          src={product.image as any}
          // shape='tall'
          size='big'
          type='image'
          classes={{ root: classes.image, middle: classes.middle }}
        />
        {/* <AbsoluteDiscount value={product.discountAbsolute} currency={currency} /> */}
        <PercentDiscount value={product.discountPercent} />
      </ProductDetailLink>
    </div>
  );
});

CataloguePageListContentItemCardImage.displayName = 'CataloguePageListContentItemCardImage';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardImage);

const elementStyles = (absolute?: boolean) => (theme: Theme) => ({
  root: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
    ...(absolute ? { textDecoration: 'line-through' } : {}),
  },
});
// const AbsoluteDiscount = withStyles(elementStyles(true))(ProductDiscountAbsoluteElement);
const PercentDiscount = withStyles(elementStyles(false))(
  ProductDiscountPercentElement,
) as typeof ProductDiscountPercentElement;
